import clsx from 'clsx';
import { CSSProperties } from 'react';

import LockIcon from 'src/assets/images/icons/small-lock-icon.png';
import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';
import { getImagePath } from 'src/utils/url.utils';

import './assignment-image.scss';

type Props = {
  distorted?: boolean;
  imagePath?: string;
  classNames?: string;
  shouldConstructImagePath?: boolean;
  locked?: boolean;
};

export const AssignmentImage = ({
  distorted,
  imagePath,
  classNames,
  shouldConstructImagePath = true,
  locked,
}: Props) => {
  const isMiddleSchoolView = useIsMiddleSchoolView();

  const getBackgroundImageStyles = () => {
    if (!imagePath) {
      return '';
    }

    if (shouldConstructImagePath) {
      return `url("${getImagePath(imagePath)}")`;
    }

    return `url("${imagePath}")`;
  };

  const imageStyles = {
    '--assignment-image-border': 'var(--new-assignment-image-border)',
    backgroundImage: getBackgroundImageStyles(),
  } as CSSProperties;

  return (
    <div
      className={clsx(
        'assignment-img',
        {
          'assignment-img--distorted': distorted,
          'assignment-img--distorted-middle-school':
            distorted && isMiddleSchoolView,
          'assignment-img--middle-school': isMiddleSchoolView,
        },
        classNames,
      )}
      style={imageStyles}
      aria-hidden
    >
      {locked && (
        <img className="assignment-img__lock" src={LockIcon} alt="lock-icon" />
      )}
    </div>
  );
};
